export default {"src":"/_next/static/media/boy.5035585a.svg","height":500,"width":500};